import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../blocks/CarouselItem";
import Source from "../../items/Source";
import SwitchControl from "../../switch/SwitchControl";

import {BarChart} from "d3plus-react";

import {numberWithCommas, removeDecimalsIfNotNeeded} from "../../../helpers/formatters";


class OccEmploymentShare extends Component {

  render() {
    const {occData, year, title, selectedOccupation, selectedShare} = this.props;
    const mode = selectedShare.key;
    const mySubtitle = mode === 'absolute' ? `Occupations employment, ${year === 2018 ? 2018 : '2018-30'}, in thousands` : `Occupations employment share, ${year === 2018 ? 2018 : '2018-30'}, %`;
    const subtitle = this.props.subtitle || mySubtitle;
    const selectedOccId = selectedOccupation.id;
    const targetYear = year || '2018';
    let descending = true;
    let metricName = mode === 'absolute' ? `${selectedOccupation.name} employment in ${targetYear} (thousands)` : `${selectedOccupation.name} share of employment in ${targetYear} (percent)`;
    let metric = mode === 'absolute' ? `employment_in_occupation_${targetYear}_thousands` : `share_of_employment_in_occupation_${targetYear}_percent`;
    let formatter = mode === 'absolute' ? numberWithCommas : x => `${removeDecimalsIfNotNeeded(x*100)}%`;

    let filteredData = occData.filter(row => row.isco_2_id === selectedOccId);
    filteredData = filteredData.sort((a, b) => descending ? b[metric] - a[metric] : a[metric] - b[metric]);

    if (filteredData.length === 0){
      return '';
    }

    let maxValue = filteredData[0][metric];
    maxValue = mode === 'absolute' ? Math.ceil(maxValue) + 10 : Math.round(Math.ceil(maxValue*100))/100;

    const chartConfig = {
      data: filteredData,
      detectVisible: true,
      height: 300,
      discrete: "y",
      groupBy: "metro_name",
      shapeConfig: {
        Bar: {
          label: (d) => (`${formatter(d[metric])}`),
          duration: 500,
          fill: d => "rgb(0, 28, 45)"
        }
      },
      tooltipConfig: {
        body: d => `<div>${metricName}: ${formatter(d[metric])}</div>`
      },
      x: metric,
      xConfig: {
        tickFormat: tick => `${formatter(tick)}`,
        domain: [0, maxValue]
      },
      y: "metro_name",
      ySort: descending ? (a, b) => a[metric] - b[metric] :  (a, b) => b[metric] - a[metric],
    };

    return (
      <CarouselItem title={title} subtitle={subtitle} >
        <div className="fow-col fow-col-1">
          <div className="fow-row">
            <div className="fow-col fow-col-1-4 fow-lg-col-1-3 fow-md-col-1-2 fow-sm-col-1">
              <SwitchControl label={false} optionsKey="share_occ" options={[{key: "absolute", value: "Absolute"}, {key: "relative", value: "Relative"}]} />
            </div>
          </div>
          <div className="fow-row">
            <div className="fow-col fow-col-1">
              <BarChart config={chartConfig} />
              <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
            </div>
          </div>
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    occData: state.db.data.facts.occupational_shares ? state.db.data.facts.occupational_shares : [],
    selectedOccupation: state.settings.map["Occupations"],
    selectedShare: state.settings.switch.share_occ
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OccEmploymentShare);
